import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialItem from "../TestimonialItem";

const SimpleSlider = (props) => {
  const { testimonialsList } = props;

  let settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {testimonialsList.map((eachTestomany) => (
        <TestimonialItem
          key={eachTestomany.id}
          testimonialDetails={eachTestomany}
        />
      ))}
    </Slider>
  );
};

export default SimpleSlider;
